//
// Game Loader
//

Loader = {};
Loader.isLoaded = false;
Loader.minTimerExpired = false;
Loader.readyForSplash = false;
Loader.crtPercent = 0;

autoplayManager.containerName = "autoplayContainer:autoplayBackground";

Loader.initialise = function (container) {
  Loader.container = container;

  Loader.doTextMapping();

  if (gameController.license === "" || gameController.license === undefined) {
    gameController.license = "default";
  }

  const license = gameController.license.toUpperCase();

  // Setup callback functions
  resourceManager.registerLoadCompleteCallback(Loader.onLoadComplete);
  resourceManager.registerLoadProgressCallback(Loader.onLoadProgress);
  Reflex.registerEventHandler("ready", Loader.onLayoutComplete);
};

Loader.doTextMapping = function () {
  const isMobile = gdk.deviceInfo.mobile;

  if (isMobile) {
    gdk.addConfigValue("textReplacementContinue", "t_TouchToContinue");
  } else {
    gdk.addConfigValue("textReplacementContinue", "t_ClickToContinue");
  }
};

Loader.onResize = function (width, height, isLandscape) {
  if (Loader.loaderBackground !== undefined) {
    var scale = Math.max(
      width / Loader.loaderBackground.texture.width,
      height / Loader.loaderBackground.texture.height
    );
    Loader.loaderBackground.scale.x = scale;
    Loader.loaderBackground.scale.y = scale;
    Loader.loaderBackground.position.x = width / 2;
    Loader.loaderBackground.position.y = height / 2;
  }
};

Loader.onLoadComplete = function (loadGroup, resources) {
  if (loadGroup === "loading") {
    globalThis.__PIXI_STAGE__ = systemData.stage;
    globalThis.__PIXI_RENDERER__ = systemData.renderer;

    Loader.progressBar = resourceManager.get("loaderContainer:loadingBar:loadingProgressBar");

    Loader.loadMask = resourceManager.get("loaderContainer:loadingBar:loadingMask");
    Loader.loadMask.beginFill(0xffffff);
    Loader.loadMask.drawRect(0, 0, 500, 40);
    Loader.loadMask.endFill();

    Loader.loadMask.pivot.x = 0;
    Loader.loadMask.scale.x = 0;
    Loader.progressBar.mask = Loader.loadMask;

    Loader.setLoadProgress(0);

    Reflex.registerEventHandler("layoutChange", Loader.layoutChange);

    resourceManager.getContainer("loadingContainer").visible = true;
    resourceManager.getContainer("backgroundContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = false;
    resourceManager.getContainer("darkOverlayContainer").visible = true;

    const loadingData = gdk.getPlatformLoadingData();
    let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo) ? loadingData.gamCareLogo : false;
    let isPreloadMessageVisible = checkForDefined(loadingData.message);
    resourceManager.get("GamCareContainerPreLoad:gamCareLogo").visible = isGamCareLogoVisible;
    resourceManager
      .get("GamCareContainerPreLoad:preLoadMessage")
      .setText(isPreloadMessageVisible ? loadingData.message : "");
    resourceManager.get("GamCareContainerPreLoad").visible =
      isGamCareLogoVisible || (isPreloadMessageVisible && loadingData.message.length != 0);

    Loader.minTimerExpired = true;
    Loader.checkCanGoToSplash();
  }
};

Loader.layoutChange = function () {
  Loader.setLoadProgress(Loader.crtPercent);
};

Loader.onLoadProgress = function (percent, loadGroup) {
  if (loadGroup !== "loading") {
    Loader.crtPercent = percent;
    Loader.setLoadProgress(percent);
  }
};

Loader.onLayoutComplete = function () {
  Loader.setLoadProgress(1);
  // gameData.stakeMeter = resourceManager.get("meterContainer:stake:meter");
  // gameData.creditMeter = resourceManager.get("meterContainer:credit:meter");
  // gameData.winningsMeter = resourceManager.get("meterContainer:winnings:meter");
  // gameData.winningsMeterTitle = resourceManager.get(
  //   "meterContainer:winnings:title"
  // );
  gameData.screenDim = resourceManager.get("backgroundScreenDimObject");
  //messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);

  // loading bar finished - hide now whilst waiting for player to continue
  // resourceManager.get( "loader:loadingBarBack" ).visible = false;
  // resourceManager.get( "loader:loadingBarFrame" ).visible = false;
  // resourceManager.get( "loader:loadingProgressBack" ).visible = false;
  // resourceManager.get( "loader:loadingText" ).visible = false;
};

Loader.onGameConfigEvent = function (gameConfigTask) {
  gameData.reels = [];

  gameData.reelAnimations = [];
  gameData.bonusSymbols = [];
  gameData.inputOverlord = resourceManager.getController("inputOverlord");
  gameData.inputOverlord.setState("disabled");
  gameData.slotConfig = gameConfigTask.data.slotConfig;

  gameData.maxExposure = gameConfigTask.data.maxExposure;

  if (gameConfigTask.data.savedClientData) {
    var encoreData = gameConfigTask.data.savedClientData.meta.find(function (element) {
      return element.name === "encore";
    });
  }

  var enableEncoreButton = encoreData && encoreData.enabled;

  if (enableEncoreButton && !gameConfigTask.data.slotConfig.promotionActive) {
    // task.data.metaValue is set to true if recovering encore game
    gameData.encoreEnabled = true;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");

    if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }

    resourceManager.getController("stakeController").setStakeMultiplier(encoreData.value);
    game.changeStake(resourceManager.getController("stakeController").CurrentStake);
    game.resetWinnings();
    resourceManager.getController("stakeController").broadcastCurrentStake();
  }

  // Allow player to click through load screen
  let backgroundLandscape = resourceManager.get("splashBackgroundL");
  backgroundLandscape.setInteractiveCallbacks(function () {
    backgroundLandscape.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  let backgroundPortrait = resourceManager.get("splashBackgroundP");
  backgroundPortrait.setInteractiveCallbacks(function () {
    backgroundPortrait.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  gameData.slotConfig = gameConfigTask.data.slotConfig;

  game.stopDistances = gameConfigTask.data.stopDistances;

  // Link buttons to functions
  game.initialise(gameConfigTask);

  // Loader.setStartingSymbols();

  var slotMachine = resourceManager.getController("SlotMachine");

  // All objects are created, so create game specific data
  for (var i = 0; i < gameData.numReels; i++) {
    let reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    let startingSymbol = Loader.getStartingSymbol(i);
    // let reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

    // Copy starting symbols from server
    for (var j = 0; j < 4; ++j) {
      if (j === 0) {
        reel.setReelSymbol(j, startingSymbol);
      } else {
        let randomSymbol = Math.floor(Math.random() * 7);
        reel.setReelSymbol(j, randomSymbol);
      }
    }

    gameData.reels.push(reel);
  }

  Loader.readyForSplash = true;

  Loader.checkCanGoToSplash();
};

Loader.setStartingSymbols = function () {
  for (let i = 0; i < gameData.numReels; i++) {
    let reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    // let startSymbolIndex = helper.convertIndexToReelRow(i);
    let startingSymbol = Loader.getStartingSymbol(i);

    //Generate last reel positions, only the symbols in view are passed to us so we need to generate the pre/post apperature symbols
    // var symbol;
    for (var j = 0; j < 4; ++j) {
      if (j === 0) {
        reel.setReelSymbol(j, startingSymbol);
      } else {
        let randomSymbol = Math.floor(Math.random() * 7);
        reel.setReelSymbol(j, randomSymbol);
      }
    }
  }
};

Loader.getStartingSymbol = function (index) {
  let startSymbolIndex = helper.convertIndexToReelRow(index);
  let startingSymbol = gameData.slotConfig.startingSymbols[startSymbolIndex.reel].symbols[startSymbolIndex.row].value;

  return startingSymbol;
};

Loader.checkCanGoToSplash = function () {
  if (Loader.readyForSplash && Loader.minTimerExpired) {
    Loader.readyForSplash = false;
    Loader.minTimerExpired = false;
    resourceManager.getContainer("loadingContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = true;
    timerManager.addTimer(300, undefined, function () {
      game.goToSplash();
    });
  }
};

Loader.setLoadProgress = function (percent) {
  Loader.loadMask.scale.x = percent;
};

messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);
